<tilby-dialog-toolbar title="SETTINGS.SETTINGS.NEW_PAYMENT_CONDITION" [customActions]="customActions"/>

<tilby-dialog-content>
    <form [formGroup]="addPaymentConditionForm" class="tw-flex tw-gap-4">
        <mat-form-field id="input-name" class="tw-flex-1">
            <mat-label>{{ 'SETTINGS.SETTINGS.PAYMENT_CONDITION_FORM.NAME' | translate }}</mat-label>
            <input matInput type="text" formControlName="name">
            <mat-error [appFieldErrors]="addPaymentConditionForm.controls.name"/>
        </mat-form-field>
        <mat-form-field id="input-code" class="tw-flex-1">
            <mat-label>{{ 'SETTINGS.SETTINGS.PAYMENT_CONDITION_FORM.CODE' | translate }}</mat-label>
            <input matInput type="text" formControlName="code">
            <mat-error [appFieldErrors]="addPaymentConditionForm.controls.code"/>
        </mat-form-field>
    </form>
</tilby-dialog-content>
